// NEW FILE — follows the exact same pattern as services/WorkflowApi.js
// (the Email Workflows client API), pointed at the WhatsApp Workflow endpoints.
import axios from "axios";
import SummaryApi from "../common/SummaryApi";

const getToken = () => {
  return localStorage.getItem("ata");
};

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
});

export const createWhatsAppWorkflow = async (data) => {
  const response = await axios.post(SummaryApi.createWhatsAppWorkflow.url, data, authHeaders());
  return response.data;
};

export const listWhatsAppWorkflows = async () => {
  const response = await axios.get(SummaryApi.listWhatsAppWorkflows.url, authHeaders());
  return response.data;
};

export const getWhatsAppWorkflow = async (id) => {
  const { url } = SummaryApi.getWhatsAppWorkflow(id);
  const response = await axios.get(url, authHeaders());
  return response.data;
};

export const updateWhatsAppWorkflow = async (id, data) => {
  const { url } = SummaryApi.updateWhatsAppWorkflow(id);
  const response = await axios.put(url, data, authHeaders());
  return response.data;
};

export const deleteWhatsAppWorkflow = async (id) => {
  const { url } = SummaryApi.deleteWhatsAppWorkflow(id);
  const response = await axios.delete(url, authHeaders());
  return response.data;
};

export const testRunWhatsAppWorkflow = async (id, payload = {}) => {
  const { url } = SummaryApi.testRunWhatsAppWorkflow(id);
  const response = await axios.post(url, { payload }, authHeaders());
  return response.data;
};

export const listWhatsAppWorkflowExecutions = async (id) => {
  const { url } = SummaryApi.listWhatsAppWorkflowExecutions(id);
  const response = await axios.get(url, authHeaders());
  return response.data;
};

// Org-wide history across every WhatsApp workflow
export const getWhatsAppWorkflowHistory = async () => {
  const response = await axios.get(SummaryApi.getWhatsAppWorkflowHistory.url, authHeaders());
  return response.data;
};
